'use client';
import React, { useEffect, useRef } from 'react';

const ZapierChatbot = () => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Load script
    if (!document.getElementById('zapier-interfaces-script')) {
      const script = document.createElement('script');
      script.id = 'zapier-interfaces-script';
      script.type = 'module';
      script.async = true;
      script.src =
        'https://interfaces.zapier.com/assets/web-components/zapier-interfaces/zapier-interfaces.esm.js';
      document.head.appendChild(script);
    }

    // Create element after potential load delay
    const timer = setTimeout(() => {
      if (
        containerRef.current &&
        !containerRef.current.querySelector('zapier-interfaces-chatbot-embed')
      ) {
        const chatbot = document.createElement(
          'zapier-interfaces-chatbot-embed'
        );
        chatbot.setAttribute('is-popup', 'false');
        chatbot.setAttribute('chatbot-id', 'cm6g3sz1v001cl2yac45jdua6');
        chatbot.style.width = '100%';
        chatbot.style.height = '100%';
        chatbot.style.display = 'block';
        containerRef.current.appendChild(chatbot);
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="container-fluid p-0 vh-100">
      <div className="row g-0 h-100">
        {/* Add padding container */}
        <div className="col-12 py-3 h-100 d-flex justify-content-center">
          {/* Main chat container with proper dimensions */}
          <div
            ref={containerRef}
            className="h-75 w-100"
            style={{
              maxWidth: '600px',
              borderRadius: '12px',
              overflow: 'hidden',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
              border: '1px solid #e0e0e0',
              display: 'flex',
              flexDirection: 'column',
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ZapierChatbot;
